export default class GlobalVar{ //Variaveis e Funcoes Globais
  static serverIp = 'https://api.encomendas.babita.com.br'
  static serverPort = '' 

  static getSessionStorage(chave){
    let keyJson = sessionStorage.getItem(chave)
    return keyJson ? JSON.parse(keyJson) : null
  }

  static setSessionStorage(chave, valor){
    return sessionStorage.setItem(chave,JSON.stringify(valor));
  }

  static getLocalStorage(chave){
    let keyJson = localStorage.getItem(chave)
    return keyJson ? JSON.parse(keyJson) : null
  }

  static setLocalStorage(chave, valor){
    return localStorage.setItem(chave,JSON.stringify(valor));
  }
  
  

  static destructObj = (obj) => JSON.parse(JSON.stringify(obj))

  static converterDataISOParaFormatoBR(dataISO) {
    const meses = [
      'JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN',
      'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'
    ];
    const data = new Date(dataISO);
    const dia = data.getUTCDate();
    const mes = meses[data.getUTCMonth()];
    const ano = data.getUTCFullYear();
    return `${dia.toString().padStart(2, '0')} ${mes} ${ano}`;
  }

  static converterDataDMA(dataISO) {
    let data = new Date(dataISO);
    let dia = data.getUTCDate();
    let mes = data.getUTCMonth() + 1; // Os meses começam do 0, então adicionamos 1.
    let ano = data.getUTCFullYear();

    // Adiciona um zero à esquerda se o dia ou o mês for menor que 10.
    if(dia < 10) dia = '0' + dia;
    if(mes < 10) mes = '0' + mes;

    return `${dia}/${mes}/${ano}`;
  }

  static converteFloat = (valor) => {
    return parseFloat(valor).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2});
  }

  static converteReais = (valor) => {
    return `R$ ${parseFloat(valor).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}).toString()}`
  }


  static formatarData(data) {
    const ano = data.getUTCFullYear();  // Obtém o ano em UTC
    const mes = String(data.getUTCMonth() + 1).padStart(2, '0');  // Obtém o mês em UTC (0-11, por isso somamos 1)
    const dia = String(data.getUTCDate()).padStart(2, '0');  // Obtém o dia em UTC

    return [dia, mes, ano];
  }

  static primeiroDiaDoMes(){
      let diaAtual = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      diaAtual = this.formatarData(diaAtual)
      return `${diaAtual[2]}-${diaAtual[1]}-${diaAtual[0]}`
  }

  static diaAtualFunc(){
      let diaAtual = this.formatarData(new Date());
      return `${diaAtual[2]}-${diaAtual[1]}-${diaAtual[0]}`
  }

  static converterDataISOParaFormatoBR(dataISO) {
    const meses = [
      'JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN',
      'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'
    ];
    const data = new Date(dataISO);
    const dia = data.getUTCDate();
    const mes = meses[data.getUTCMonth()];
    const ano = data.getUTCFullYear();
    return `${dia.toString().padStart(2, '0')} ${mes} ${ano}`;
  }

  static ordenarTamanhos(tamanhos) {
    if (!Array.isArray(tamanhos)) return []
  
    const ordemTexto = [
      'pp',
      'p',
      'm',
      'g',
      'gg',
      'xg',
      'xxg',
      'único',
      'unico'
    ]
  
    return [...tamanhos].sort((a, b) => {
      const ta = a.toString().trim().toLowerCase()
      const tb = b.toString().trim().toLowerCase()
  
      const na = parseFloat(ta.replace(',', '.'))
      const nb = parseFloat(tb.replace(',', '.'))
  
      const aIsNumber = !isNaN(na)
      const bIsNumber = !isNaN(nb)
  
      // 1️⃣ números primeiro
      if (aIsNumber && bIsNumber) return na - nb
      if (aIsNumber && !bIsNumber) return -1
      if (!aIsNumber && bIsNumber) return 1
  
      // 2️⃣ texto conhecido (PP, P, M, G...)
      const ia = ordemTexto.indexOf(ta)
      const ib = ordemTexto.indexOf(tb)
  
      if (ia !== -1 && ib !== -1) return ia - ib
      if (ia !== -1) return -1
      if (ib !== -1) return 1
  
      // 3️⃣ fallback alfabético
      return ta.localeCompare(tb, 'pt-BR', {
        sensitivity: 'base',
        numeric: true,
      })
    })
  }
  

}

